import {isNullOrUndefined} from "../../../services/Validator";

export default function GlossaryLetterItem({letter, scrollToLetter}) {
    // Used in GlossaryLettersList to display one single letter

    // BUILD
    if (isNullOrUndefined(letter) || isNullOrUndefined(scrollToLetter))
        return null
    return (
        <div className={"cursor-pointer w-[24px] min-w-[24px] h-[32px] min-h-[32px] flex justify-center items-center rounded-[6px] text-medium text-[18px] bg-transparent  border-violetGrey hover:bg-blueBackground hover:border-timerBlue border-[1px] text-greyLight9 hover:text-white"}
             onClick={scrollToLetter}>
            <span>
                {letter}
            </span>
        </div>
    );
}